import React from 'react';
import {Space} from 'antd';
import {observer} from "mobx-react";
import {useNavigate} from "react-router-dom";
import * as User from "../index";

export const Add: React.FC = observer(() => {
    const navigate = useNavigate();

    const onCancel = () => {
        navigate(`/user`)
    }

    return (
        <Space direction="vertical" size="small" style={{ display: 'flex' }}>
            <User.AddForm onCancel={onCancel} />
        </Space>
    )
})